import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { IMAGES } from '../../lib/constants';
const INCLUDES = ['6 Tomos Clínicos Premium', '5 Bonos Exclusivos', 'Más de 300 páginas prácticas', 'Casos clínicos resueltos', 'Checklists y protocolos listos para usar'];
export function Hero() {
  return <header className="w-full bg-cream px-4 pb-12 pt-8 sm:pb-16 sm:pt-12" data-id="element-197" data-mp="muahcjljg92y">
      <div className="mx-auto max-w-3xl" data-id="element-198" data-mp="ms7olrt041uj">
        <div className="mb-7 flex flex-col items-center gap-2" data-id="element-199" data-mp="qukjfl67mfcj">
          <span className="font-display text-lg font-bold tracking-tight text-navy-900" data-id="element-200" data-mp="vmc9zvpd8l2o">
            Dra. <span className="text-gold-600" data-id="element-201" data-mp="10lfi5p0n77ev">Karito</span>
          </span>
          <span className="text-[10px] font-semibold uppercase tracking-[0.22em] text-navy-400" data-id="element-202" data-mp="10knju6fnuvkw">
            Sistema de Diagnóstico Facial
          </span>
        </div>

        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="text-center font-display text-[30px] font-bold leading-[1.1] tracking-tight text-navy-900 sm:text-5xl" data-id="element-203" data-mp="1ako886se01vy">
          Diagnostica con mayor seguridad en solo{' '}
          <span className="text-gold-600" data-id="element-204" data-mp="3vx3niy5m3f7k">15 minutos</span>
        </motion.h1>

        <p className="mx-auto mt-4 max-w-xl text-center text-[15px] leading-relaxed text-navy-600 sm:text-lg" data-id="element-205" data-mp="3rv0aw677i4kp">
          El método paso a paso que integra el análisis del rostro con la cefalometría para
          respaldar cada decisión clínica. Deja de depender únicamente de los números y evalúa cada
          caso con un proceso claro, ordenado y repetible.
        </p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="mt-7" data-id="element-206" data-mp="enp3jw4kg8we">
          <img src={IMAGES.mockup} alt="Sistema de Diagnóstico Facial: 6 tomos clínicos y 5 bonos en formato digital" className="mx-auto w-full max-w-2xl" width={1280} height={1280} data-id="element-207" data-mp="16d0m98884wmc" />
        </motion.div>

        <div className="mx-auto mt-6 max-w-md rounded-3xl border border-navy-100 bg-white p-4 shadow-card sm:p-5" data-id="element-208" data-mp="2qwdy9ealqz6l">
          <p className="mb-3 text-center text-[11px] font-bold uppercase tracking-[0.16em] text-gold-600" data-id="element-209" data-mp="2vufc9kt688b7">
            Incluye
          </p>
          <ul className="space-y-2.5" data-id="element-210" data-mp="2hu4lsivrwvqk">
            {INCLUDES.map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-211" data-mp="2mvaisswgv55w">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-gold-100" data-id="element-212" data-mp="27xrrbisemdur">
                  <CheckIcon className="h-3.5 w-3.5 text-gold-700" aria-hidden="true" data-id="element-213" data-mp="2cxe5pvjyy055" />
                </span>
                <span className="text-[14.5px] font-medium leading-snug text-navy-800" data-id="element-214" data-mp="676liej8sltq">{item}</span>
              </li>)}
          </ul>

          <div className="mt-5" data-id="element-215" data-mp="1vn0jb85ckqnw">
            <CtaButton id="hero-cta" label="Quiero el Sistema de Diagnóstico Facial" location="hero" note="Descarga inmediata • Pago único • Acceso de por vida • Garantía de 7 días" data-id="element-216" data-mp="1vo26gazn13lz" />
          </div>
        </div>
      </div>
    </header>;
}